<template>
  <div id="app" class="box">
    <!-- <h-navigation ng-show="showHomeHeader"></h-navigation> -->
    <!-- <router-view /> -->
    <!-- <keep-alive include='Home'>
      <router-view />
    </keep-alive> -->
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import HNavigation from '@/components/HNavigation'
export default {
  name: 'App',
  components: {
    HNavigation
  },
  data () {
    return {
      showHomeHeader: false
    }
  },
  created () {
    console.log(`this.$store.showHomeHeader:${this.$store.state.showHomeHeader}`)
    this.showHomeHeader = this.$store.state.showHomeHeader
  },
  methods: {},
  computed: {
  }
}
</script>

<style lang="scss">
// @import '~@/assets/scss/main';
@import '~@/components/sffui/assets/scss/base';
.box{
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue